import React from "react";
import { Route, Redirect } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { connect } from "react-redux";

import App from "./containers/App/App";
import asyncComponent from "./helpers/AsyncFunc";

const RestrictedRoute = ({ component: Component, isLoggedIn, consentAccepted, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!isLoggedIn) {
        return (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: props.location }
            }}
          />
        );
      }
      if (consentAccepted !== true) {
        return <Redirect to={{ pathname: "/consent" }} />;
      }
      return <Component {...props} />;
    }}
  />
);

const PublicRoutes = ({ history, isLoggedIn, consentAccepted }) => {
  return (
    <ConnectedRouter history={history}>
      <div>
        <Route
          exact
          path={"/"}
          component={asyncComponent(() => import("./containers/Page/signin"))}
        />
        <Route
          exact
          path={"/signin"}
          component={asyncComponent(() => import("./containers/Page/signin"))}
        />
         <Route
          exact
          path={"/forgot-pin"}
          component={asyncComponent(() => import("./containers/Page/forgotPin"))}
        />
         <Route
          exact
          path={"/consent"}
          component={asyncComponent(() => import("./containers/Page/ConsentPage"))}
        />
        <Route
          exact
          path={"/signup"}
          component={asyncComponent(() => import("./containers/Page/signup"))}
        />
        <Route
          exact
          path={"/forgotpass"}
          component={asyncComponent(() =>
            import("./containers/Page/forgotpass")
          )}
        />

        <Route
          exact
          path={"/resetpass"}
          component={asyncComponent(() =>
            import("./containers/Page/resetpass")
          )}
        />

        <Route
          exact
          path={"/menu"}
          component={asyncComponent(() => import("./containers/Main/menu"))}
        />
        
        <RestrictedRoute
          path="/dashboard"
          component={App}
          isLoggedIn={isLoggedIn}
          consentAccepted={consentAccepted}
        />
      </div>
    </ConnectedRouter>
  );
};

export default connect(state => ({
  isLoggedIn: state.Auth.idToken !== null,
  consentAccepted:
    state.Auth &&
    state.Auth.credentials &&
    state.Auth.credentials.data &&
    state.Auth.credentials.data.consentAccepted,
}))(PublicRoutes);
